export const integerOnly =
  (message = "Doit être un nombre entier positif") =>
  (value: any) =>
    value == null || value === "" || /^\d+$/.test(String(value))
      ? undefined
      : message;
